import { Checkbox } from '@lmn/design-system';
import styled from 'styled-components';

const CHECKBOX_MIN_HEIGHT = { evo: '40px', current: '48px' };

const TsxCheckbox = styled(Checkbox)<{ $evo?: boolean }>`
  // Checkbox__Label
  &.checkbox {
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    min-height: ${({ $evo }) => ($evo ? CHECKBOX_MIN_HEIGHT.evo : CHECKBOX_MIN_HEIGHT.current)};
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding: 0;

    // --- Button ---
    button {
      // Default
      border-color: ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
      border-width: 2px;

      &[data-state='checked'] {
        background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
        border-color: transparent;
      }

      &[data-disabled] {
        border-color: ${({ theme }) => theme.kallisto.color.border.static.borderDisabled};
      }

      &[data-state='checked'][data-disabled] {
        background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundDisabled};
        border-color: ${({ theme }) => theme.kallisto.color.border.static.borderDisabled};
      }

      // Hover
      &:hover {
        border-color: ${({ theme }) => theme.kallisto.color.border.interactive.borderPrimaryHover};
      }
    }

    // --- Checkbox__LabelContent (wraps LabelText) ---
    [class*='LabelContent'] {
      min-width: 0;
    }

    // --- Checkbox__LabelText ---
    [class*='LabelText'] {
      width: 100%;
      min-width: 0;
      display: inline-flex;
      align-items: center;

      [class*='Text'] {
        display: block;
        min-width: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      > [class*='Counter'] {
        .sidebar & {
          margin-left: auto;
        }

        @media (max-width: 768px) {
          margin-left: auto;
        }
      }
    }

    // --- Wrapper hover ---
    &:hover {
      background-color: transparent;

      // Enabled: hovered
      button:not([data-disabled]) {
        border-color: ${({ theme }) => theme.kallisto.color.border.interactive.borderPrimaryDefault};

        // Enabled + checked: hovered
        &[data-state='checked'] {
          background-color: ${({ theme }) => theme.kallisto.color.background.static.borderPrimaryHover};
        }
      }

      // Disabled: hovered
      button[data-disabled] {
        border-color: ${({ theme }) => theme.kallisto.color.border.static.borderDisabled};
      }
    }
  }
`;

export default TsxCheckbox;
